// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ph-container {
  container-type: inline-size;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  cursor: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* Content wrapper for flex layout */
.ph-container .ph-content-wrapper {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
}

/* scrollable table container */
.ph-container .ph-table-container {
  overflow-y: auto;
  flex: 1 1 auto;
  min-height: 0;
}

.ph-container .ph-table {
  width: 100%;
  border-collapse: collapse;
  margin: 0;
}

.ph-container .ph-table thead th {
  box-shadow: inset 0 -1px 0 var(--border-line);
  height: 32px;
  box-sizing: border-box;
  text-align: right;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: var(--text-subheader);
  vertical-align: top;
  white-space: nowrap;
}
.ph-container .ph-table thead th:first-child {
  box-shadow: none;
}

.ph-container .ph-table thead th.no {
  text-align: center;
  width: 8px;
  padding-right: 8px;
}

.ph-container .ph-table thead th.ctry {
  width: 28px;
  min-width: 28px;
  padding-right: 8px;
}

.ph-container .ph-table thead th.ticker {
  text-align: left;
  width: 62px;
  min-width: 62px;
  padding-right: 8px;
}

.ph-container .ph-table thead th.name {
  text-align: left;
  min-width: 150px;
}
.ph-container .ph-table thead th.date {
  text-align: left;
  min-width: 80px;
}
.ph-container .ph-table thead th.tickerName {
  text-align: left;
}

.ph-container .ph-table thead th.perf1D {
  padding-right: 8px;
  text-align: center;
}

.ph-container .ph-table thead th:last-child {
  width: 32px;
  max-width: 32px;
  box-shadow: none;
}

.ph-container .ph-table thead th.sortable {
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s ease;
}

.ph-container .ph-table thead th.sortable svg {
  width: 16px;
  height: 16px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 4px;
  transition: transform 0.2s ease;
}

.ph-container .ph-table tbody td.highlighted {
  font-weight: bold !important;
}
.ph-container .ph-table tbody tr {
  vertical-align: middle;
  height: 40px;
}
.ph-container .ph-table tbody tr:nth-child(2n) {
  background-color: var(--row-dark);
}

.ph-container .ph-table tbody td {
  text-align: right;
  font-size: 16px;
  line-height: 24px;
  color: var(--text-primary);
  padding: 8px 0;
  box-sizing: border-box;
}

.ph-container .ph-table tbody:first-of-type td {
  padding-bottom: 24px;
}

.ph-container .ph-table tbody td:first-child {
  width: 32px;
  max-width: 32px;
}

.ph-container .ph-table tbody td.nochange {
  color: var(--text-unchg-color);
}

.ph-container .ph-table tbody td.positive {
  color: var(--text-up-color);
}

.ph-container .ph-table tbody td.negative {
  color: var(--text-down-color);
}

.ph-container .ph-table tbody td.no {
  text-align: justify;
  font-size: 12px;
  line-height: 20px;
  color: var(--text-subheader);
  padding-right: 8px;
}

.ph-container .ph-table tbody td.ctry {
  text-align: left;
  width: 28px;
  max-width: 28px;
}

.ph-container .ph-table tbody td.ctry svg {
  width: 20px;
  height: 20px;
}

.ph-container .ph-table tbody td.ticker {
  text-align: left;
  text-decoration: underline;
  color: var(--text-subheader);
  padding-right: 8px;
}

.ph-container .ph-table tbody td.name {
  text-align: left;
  color: var(--text-subheader);
  cursor: pointer;
}
.ph-container .ph-table tbody td.date {
  text-align: left;
}
.ph-tbl-cel-text {
  white-space: pre-wrap !important;
}
.ph-container .ph-table tbody td.tickerName {
  text-align: left;
  padding-top: 8px;
}

.ph-container .ph-table tbody td.tickerName .ticker {
  text-decoration: underline;
  color: var(--text-subheader);
}

.ph-container .ph-table tbody td.tickerName .name {
  text-align: left;
  font-size: 12px;
  color: var(--text-subheader);
  padding-right: 8px;
}

.ph-container .ph-table tbody td.last {
  min-width: 77px;
  padding-right: 8px;
}

.ph-container .ph-table tbody td.noborder {
  border: none !important;
}

.ph-container .ph-table tbody td.perf1D {
  border: 1px solid var(--border-primary);
  min-width: 120px;
  padding-right: 8px;
  max-height: 56px;
}

.ph-container .ph-table tbody td.lastcolumn {
  width: 0;
  border: none;
}

.ph-container .ph-table tfoot td {
  height: 52px;
  padding-left: 24px;
  text-align: left;
  font-size: 12px;
  line-height: 20px;
  color: var(--text-subheader);
}

.ph-container {
  .rec-strong-buy {
    background-color: var(--heatmap-up-5);
    color: var(--text-invert);
  }

  .rec-buy {
    background-color: var(--heatmap-up-4);
    color: var(--text-invert);
  }

  .rec-hold {
    background-color: var(--surface-secondary);
    color: var(--text-primary);
  }

  .rec-reduce {
    background-color: var(--heatmap-down-4);
    color: var(--text-invert);
  }

  .rec-sell {
    background-color: var(--heatmap-down-5);
    color: var(--text-invert);
  }

  .ph-whitespace {
    height: 24px;
  }

  .ph-pagination-container {
    flex-shrink: 0;
    display: flex;
    align-items: center;

    /* Override style in pagination */
    .pagination-background {
      padding: 16px 24px;
      background: linear-gradient(180deg, #ffffff 0%, #f4f4f4 100%);
    }
  }

  .ph-pagination {
    padding: 32px;
    background-color: var(--surface-primary);
  }

  .alignRight {
    text-align: right;
  }

  .alignCenter {
    text-align: center;
  }

  .ph-tbl-cel-flex-container {
    display: flex;
    align-items: center;
    max-width: 90%;
  }

  .ph-tbl-cel-text {
    flex: 1 1 0;
    min-width: 0; /* critical for ellipsis in flex items */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
@container (min-width: 360px) {
  .ph-container .ph-table thead th:first-child,
  .ph-container .ph-table thead th:last-child,
  .ph-container .ph-table tbody td:first-child,
  .ph-container .ph-table tbody td:last-child {
    width: 24px;
    max-width: 24px;
  }
}

@container (min-width: 768px) {
  .ph-container .ph-table thead th:first-child,
  .ph-container .ph-table thead th:last-child {
    width: 32px;
    max-width: 32px;
  }

  .ph-container .ph-table tbody td.perf1D {
    width: 10%;
    min-width: 95px;
  }
}

@container (max-width: 767px) {
  .ph-container .ph-table thead th.perf1D {
    text-align: right;
    padding-right: 0px;
  }

  .ph-container .ph-table tbody td.perf1D {
    padding-right: 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/PriceHistoryWidget/PriceHistoryWidget.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,YAAY;AACd;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,6CAA6C;EAC7C,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;AAC9B;AACA;EACE,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE;IACE,qCAAqC;IACrC,yBAAyB;EAC3B;;EAEA;IACE,qCAAqC;IACrC,yBAAyB;EAC3B;;EAEA;IACE,0CAA0C;IAC1C,0BAA0B;EAC5B;;EAEA;IACE,uCAAuC;IACvC,yBAAyB;EAC3B;;EAEA;IACE,uCAAuC;IACvC,yBAAyB;EAC3B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,cAAc;IACd,aAAa;IACb,mBAAmB;;IAEnB,iCAAiC;IACjC;MACE,kBAAkB;MAClB,6DAA6D;IAC/D;EACF;;EAEA;IACE,aAAa;IACb,wCAAwC;EAC1C;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY,EAAE,wCAAwC;IACtD,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;AACF;AACA;EACE;;;;IAIE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".ph-container {\n  container-type: inline-size;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  cursor: auto;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Content wrapper for flex layout */\n.ph-container .ph-content-wrapper {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-height: 0;\n  height: 100%;\n}\n\n/* scrollable table container */\n.ph-container .ph-table-container {\n  overflow-y: auto;\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n.ph-container .ph-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 0;\n}\n\n.ph-container .ph-table thead th {\n  box-shadow: inset 0 -1px 0 var(--border-line);\n  height: 32px;\n  box-sizing: border-box;\n  text-align: right;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--text-subheader);\n  vertical-align: top;\n  white-space: nowrap;\n}\n.ph-container .ph-table thead th:first-child {\n  box-shadow: none;\n}\n\n.ph-container .ph-table thead th.no {\n  text-align: center;\n  width: 8px;\n  padding-right: 8px;\n}\n\n.ph-container .ph-table thead th.ctry {\n  width: 28px;\n  min-width: 28px;\n  padding-right: 8px;\n}\n\n.ph-container .ph-table thead th.ticker {\n  text-align: left;\n  width: 62px;\n  min-width: 62px;\n  padding-right: 8px;\n}\n\n.ph-container .ph-table thead th.name {\n  text-align: left;\n  min-width: 150px;\n}\n.ph-container .ph-table thead th.date {\n  text-align: left;\n  min-width: 80px;\n}\n.ph-container .ph-table thead th.tickerName {\n  text-align: left;\n}\n\n.ph-container .ph-table thead th.perf1D {\n  padding-right: 8px;\n  text-align: center;\n}\n\n.ph-container .ph-table thead th:last-child {\n  width: 32px;\n  max-width: 32px;\n  box-shadow: none;\n}\n\n.ph-container .ph-table thead th.sortable {\n  cursor: pointer;\n  user-select: none;\n  transition: background-color 0.2s ease;\n}\n\n.ph-container .ph-table thead th.sortable svg {\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 4px;\n  transition: transform 0.2s ease;\n}\n\n.ph-container .ph-table tbody td.highlighted {\n  font-weight: bold !important;\n}\n.ph-container .ph-table tbody tr {\n  vertical-align: middle;\n  height: 40px;\n}\n.ph-container .ph-table tbody tr:nth-child(2n) {\n  background-color: var(--row-dark);\n}\n\n.ph-container .ph-table tbody td {\n  text-align: right;\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--text-primary);\n  padding: 8px 0;\n  box-sizing: border-box;\n}\n\n.ph-container .ph-table tbody:first-of-type td {\n  padding-bottom: 24px;\n}\n\n.ph-container .ph-table tbody td:first-child {\n  width: 32px;\n  max-width: 32px;\n}\n\n.ph-container .ph-table tbody td.nochange {\n  color: var(--text-unchg-color);\n}\n\n.ph-container .ph-table tbody td.positive {\n  color: var(--text-up-color);\n}\n\n.ph-container .ph-table tbody td.negative {\n  color: var(--text-down-color);\n}\n\n.ph-container .ph-table tbody td.no {\n  text-align: justify;\n  font-size: 12px;\n  line-height: 20px;\n  color: var(--text-subheader);\n  padding-right: 8px;\n}\n\n.ph-container .ph-table tbody td.ctry {\n  text-align: left;\n  width: 28px;\n  max-width: 28px;\n}\n\n.ph-container .ph-table tbody td.ctry svg {\n  width: 20px;\n  height: 20px;\n}\n\n.ph-container .ph-table tbody td.ticker {\n  text-align: left;\n  text-decoration: underline;\n  color: var(--text-subheader);\n  padding-right: 8px;\n}\n\n.ph-container .ph-table tbody td.name {\n  text-align: left;\n  color: var(--text-subheader);\n  cursor: pointer;\n}\n.ph-container .ph-table tbody td.date {\n  text-align: left;\n}\n.ph-tbl-cel-text {\n  white-space: pre-wrap !important;\n}\n.ph-container .ph-table tbody td.tickerName {\n  text-align: left;\n  padding-top: 8px;\n}\n\n.ph-container .ph-table tbody td.tickerName .ticker {\n  text-decoration: underline;\n  color: var(--text-subheader);\n}\n\n.ph-container .ph-table tbody td.tickerName .name {\n  text-align: left;\n  font-size: 12px;\n  color: var(--text-subheader);\n  padding-right: 8px;\n}\n\n.ph-container .ph-table tbody td.last {\n  min-width: 77px;\n  padding-right: 8px;\n}\n\n.ph-container .ph-table tbody td.noborder {\n  border: none !important;\n}\n\n.ph-container .ph-table tbody td.perf1D {\n  border: 1px solid var(--border-primary);\n  min-width: 120px;\n  padding-right: 8px;\n  max-height: 56px;\n}\n\n.ph-container .ph-table tbody td.lastcolumn {\n  width: 0;\n  border: none;\n}\n\n.ph-container .ph-table tfoot td {\n  height: 52px;\n  padding-left: 24px;\n  text-align: left;\n  font-size: 12px;\n  line-height: 20px;\n  color: var(--text-subheader);\n}\n\n.ph-container {\n  .rec-strong-buy {\n    background-color: var(--heatmap-up-5);\n    color: var(--text-invert);\n  }\n\n  .rec-buy {\n    background-color: var(--heatmap-up-4);\n    color: var(--text-invert);\n  }\n\n  .rec-hold {\n    background-color: var(--surface-secondary);\n    color: var(--text-primary);\n  }\n\n  .rec-reduce {\n    background-color: var(--heatmap-down-4);\n    color: var(--text-invert);\n  }\n\n  .rec-sell {\n    background-color: var(--heatmap-down-5);\n    color: var(--text-invert);\n  }\n\n  .ph-whitespace {\n    height: 24px;\n  }\n\n  .ph-pagination-container {\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n\n    /* Override style in pagination */\n    .pagination-background {\n      padding: 16px 24px;\n      background: linear-gradient(180deg, #ffffff 0%, #f4f4f4 100%);\n    }\n  }\n\n  .ph-pagination {\n    padding: 32px;\n    background-color: var(--surface-primary);\n  }\n\n  .alignRight {\n    text-align: right;\n  }\n\n  .alignCenter {\n    text-align: center;\n  }\n\n  .ph-tbl-cel-flex-container {\n    display: flex;\n    align-items: center;\n    max-width: 90%;\n  }\n\n  .ph-tbl-cel-text {\n    flex: 1 1 0;\n    min-width: 0; /* critical for ellipsis in flex items */\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n@container (min-width: 360px) {\n  .ph-container .ph-table thead th:first-child,\n  .ph-container .ph-table thead th:last-child,\n  .ph-container .ph-table tbody td:first-child,\n  .ph-container .ph-table tbody td:last-child {\n    width: 24px;\n    max-width: 24px;\n  }\n}\n\n@container (min-width: 768px) {\n  .ph-container .ph-table thead th:first-child,\n  .ph-container .ph-table thead th:last-child {\n    width: 32px;\n    max-width: 32px;\n  }\n\n  .ph-container .ph-table tbody td.perf1D {\n    width: 10%;\n    min-width: 95px;\n  }\n}\n\n@container (max-width: 767px) {\n  .ph-container .ph-table thead th.perf1D {\n    text-align: right;\n    padding-right: 0px;\n  }\n\n  .ph-container .ph-table tbody td.perf1D {\n    padding-right: 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
